import { useEffect } from 'react'
import { Stack } from 'expo-router'
import { useBookingStore } from '@/lib/stores/booking.store'
import { consumeBookingComplianceDetour } from '@/lib/navigation/booking-detour'
import { stableStackOptions } from '@/lib/navigation/stable-stack-options'

export default function BookingLayout() {
  // Reset booking state when the user leaves the booking flow entirely.
  // The confirmation screen also resets on "View trips", but this catches
  // browser back, swipe-back, and any other exit from the booking stack.
  //
  // UNLESS the exit is a compliance detour — a KYC or AML gate redirecting the
  // guest out to finish a declaration and come right back. That unmounts this
  // stack too, but it is not an abandonment, and resetting there wiped the
  // draft (dates, times, delivery locations, promo) the guest was sent away to
  // preserve. The gates flag it; this consumes the flag exactly once.
  useEffect(() => {
    return () => {
      if (consumeBookingComplianceDetour()) return
      useBookingStore.getState().reset()
    }
  }, [])

  return <Stack screenOptions={{ headerShown: false, ...stableStackOptions }} />
}
